import objectAssign from 'object-assign';

export function profile( state = { 
	activity: {
		statements: [],
		replies: [],
		articles: [],
		comments: [],
		bookmarks: [],
		flares: [],
	},
	interests: [], 
	bookmarks: [], 
	user: {},
	fetching: false
}, action ) {

	switch (action.type) {

		case 'REQUEST_PROFILE':
			return Object.assign({}, state, {
				user: {},
				fetching: true
			})

		case 'RECEIVE_PROFILE':
			let toUpdate = {
				activity: action.activity,
				fetching: false
			}
			if( 'interests' in action ) toUpdate.interests = action.interests
			if( 'bookmarks' in action ) toUpdate.bookmarks = action.bookmarks
			if( 'user' in action ) toUpdate.user = action.user
			return Object.assign({}, state, toUpdate)

		case 'UPDATE_PROFILE':
			var fields = ['interests']
			var newData = {
				fetching: false
			};
			for (var f = 0; f <= fields.length-1; f++) {
				if( action[fields[f]] ) newData[fields[f]] = action[fields[f]];
			}
			return Object.assign({}, state, newData)

		default:
			return state;
	}

}


// WEBPACK FOOTER //
// ./src/js/reducers/profiles.js